import {
  Flex,
  PageHeader,
  PageLayout,
  Skeleton,
  SkeletonText,
} from '@buffer-mono/popcorn'

import { CommentListSkeleton } from '../Comments/CommentsList'
import titleStyles from '../CommunityPageTitle/CommunityPageTitle.module.css'

import styles from './SingleChannelView.module.css'

import type { JSX } from 'react'

export const SingleChannelViewSkeleton = (): JSX.Element => {
  return (
    <PageLayout data-testid="comments-channel-skeleton">
      <PageHeader>
        <PageHeader.Row>
          {/* Channel avatar + name */}
          <Flex direction="row" align="center" gap="md">
            <Skeleton
              rounded
              width={48}
              height={48}
              className={titleStyles.skeletonAvatar}
            />
            <Skeleton rounded width={100} height={20} />
          </Flex>
          {/* Actions: filters, LastSyncActions, toggle */}
          <PageHeader.Actions className={styles.headerActions}>
            <PageHeader.ActionGroup>
              <Skeleton width={32} height={32} />
              <Skeleton width={32} height={32} />
              <Skeleton width={32} height={32} />
              <SkeletonText lines={1} width={100} />
            </PageHeader.ActionGroup>
            <PageHeader.ActionGroup>
              <Skeleton width={90} height={40} />
            </PageHeader.ActionGroup>
          </PageHeader.Actions>
        </PageHeader.Row>
      </PageHeader>
      <PageLayout.Container size="narrow">
        <CommentListSkeleton />
      </PageLayout.Container>
    </PageLayout>
  )
}
